import React from "react";
import { useLocation } from "react-router-dom";
import { useShortcuts } from "../../hooks/useShortcuts";
import shortcuts from "../../data/shortcuts.json";

const ShortcutsProvider = () => {
  const location = useLocation();
  const disabled = location.pathname.startsWith("/point_of_sale");
  const { showHelp, setShowHelp } = useShortcuts({}, { disabled });

  if (!showHelp) return null;

  return (
    <div
      className="shortcuts-overlay"
      onClick={() => setShowHelp(false)}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: "8px",
          padding: "24px 32px",
          maxWidth: "600px",
          width: "90%",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <h5 style={{ margin: 0 }}>Atajos de teclado</h5>
          <button
            onClick={() => setShowHelp(false)}
            style={{
              background: "none",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
              padding: "0 4px",
            }}
          >
            &times;
          </button>
        </div>

        <h6 style={{ color: "#666", marginTop: "16px" }}>
          Navegaci&oacute;n
        </h6>
        <table style={{ width: "100%", marginBottom: "16px" }}>
          <tbody>
            {shortcuts.sequences.map((seq, i) => (
              <tr key={i}>
                <td style={{ padding: "4px 8px", width: "40%" }}>
                  <kbd>{seq.keys.join(" ")}</kbd>
                  {" / "}
                  <kbd>{(seq as any).keys_es?.join(" ") || seq.keys.join(" ")}</kbd>
                </td>
                <td style={{ padding: "4px 8px" }}>{seq.label_es}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <h6 style={{ color: "#666" }}>Acciones</h6>
        <table style={{ width: "100%", marginBottom: "8px" }}>
          <tbody>
            {shortcuts.singles.map((s, i) => (
              <tr key={i}>
                <td style={{ padding: "4px 8px", width: "40%" }}>
                  <kbd>{s.key}</kbd>
                </td>
                <td style={{ padding: "4px 8px" }}>{s.label_es}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <p
          style={{
            fontSize: "12px",
            color: "#999",
            margin: "12px 0 0",
            textAlign: "center",
          }}
        >
          Presiona <kbd>?</kbd> para cerrar
        </p>
      </div>
    </div>
  );
};

export default ShortcutsProvider;
